(function () {
  function ready(callback) {
    if (document.readyState !== 'loading') {
      callback();
      return;
    }
    document.addEventListener('DOMContentLoaded', callback);
  }

  ready(function () {
    document.querySelectorAll('[data-menu-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var header = button.closest('[data-header]');
        if (!header) return;
        var isOpen = header.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(isOpen));
      });
    });

    document.querySelectorAll('[data-faq-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var item = button.closest('[data-faq-item]');
        if (!item) return;
        var panel = item.querySelector('[data-faq-panel]');
        var isOpen = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', String(isOpen));
        if (panel) panel.hidden = !isOpen;
      });
    });

    document.querySelectorAll('[data-quantity-control]').forEach(function (control) {
      var input = control.querySelector('input[type="number"]');
      if (!input) return;
      control.querySelectorAll('[data-quantity-change]').forEach(function (button) {
        button.addEventListener('click', function () {
          var delta = Number(button.getAttribute('data-quantity-change'));
          var next = Math.max(Number(input.getAttribute('min') || 1), Number(input.value || 1) + delta);
          input.value = String(next);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    document.querySelectorAll('form.product-form').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!window.fetch || !window.FormData || !window.routes || !window.routes.cart_add_url) return;
        event.preventDefault();
        var submit = form.querySelector('[type="submit"]');
        if (submit) submit.setAttribute('aria-busy', 'true');
        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            window.location.href = window.routes.cart_url || '/cart';
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (submit) submit.removeAttribute('aria-busy');
          });
      });
    });
  });
})();
